import { env } from '@automata/utils';

import { WorkflowState } from './types';
import { getEnvironmentFromUrl } from '../../../../../apps/core/src/utils/url';
import { getDriversSync } from '../../data/drivers';
import {
  DEFAULT_HARDCODED_WORKCELL_ID,
  SelectedWorkcellId,
} from '../../hooks/useGetWorkcell/types';

export const getInitialWorkcell = (): SelectedWorkcellId => {
  const baseUrlString = env('NEXT_PUBLIC_BASE_URL'); // e.g. https://app.dev.linq.cloud or http://127.0.0.1:3000 etc
  const environmentKey = getEnvironmentFromUrl(baseUrlString) ?? '';

  switch (environmentKey) {
    case 'azglobal':
      return 'azProd';
    case 'ucb':
      return 'ucbProd';
    default:
      return DEFAULT_HARDCODED_WORKCELL_ID;
  }
};

export const initialState: WorkflowState = {
  visualWorkflow: {
    batches: 1,
    comments: {},
    labwareProperties: {},
    parameterDefinitions: [],
    taskProperties: {},
    workcellName: 'Experiment 1 Workcell',
    workflowAuthor: 'Author here',
    workflowDescription: '',
    workflowName: 'Untitled Workflow',
  },
  scripts: {
    org_slug: '',
    version: '',
    functions: [],
  },
  drivers: getDriversSync(),
  labwareOffsetDefinitions: {},
  driverActionConfigs: {},
  options: {
    planner: {
      target_objective: null,
      max_computation_time: null,
      max_dead_time: null,
      preset: null,
      round_robin_load_balancing: false,
      optimisation_target: 'minimize_total_plan_duration',
      feasibility_stage: null,
      // optimisation_stages: [],
    },
  },
  showAdvancedPlannerOptions: false,
  lastPlanningTime: null,
  schedulerVersion: '',
  derived: {
    published: false,
  },
  workcellInstruments: {
    /* this will be populated by an action immediately upon VB app load */
  },
  workcellTransportConfigType: undefined,
  workcellTransportConfigVersion: undefined,
  selectedWorkcellId: getInitialWorkcell(),
};
